import { Form } from 'react-bootstrap';
import { InvoiceDto } from '../../../../models/invoice.dto';
import { useEffect, useRef, useState } from 'react';
import { useUpdateInvoiceMutation } from '../../../../store/invoices/invoices.api';
import './description.scss';

interface Props {
    invoice: InvoiceDto;
    row?: number
}

const Description = ({ invoice, row }: Props) => {
    const [description, setDescription] = useState(invoice.description);
    const inputRef = useRef<HTMLTextAreaElement>(null);
    const [updateInvoice] = useUpdateInvoiceMutation();

    useEffect(() => {
        setDescription(invoice.description);
    }, [invoice]);

    function isDescriptionChanged() {
        return description != invoice.description;
    }

    const adjustHeight = () => {
        const el = inputRef.current;
        if (el) {
            el.style.height = '35px';
            el.style.minWidth = '140px';
            el.style.height = `${el.scrollHeight}px`;
        }
    };

    useEffect(() => {
        setDescription(invoice.description);
        adjustHeight();
    }, [invoice]);

    const updateDescription = () => {
        if (isDescriptionChanged()) {
            updateInvoice({ invoiceId: invoice.invoiceId, data: { ...invoice, description } });
        }
    }

    const onKeyDown = event => {
        if (event.key === 'Enter') {
            updateDescription();
        }
    };

    const onChange = e => {
        const { value } = e.target;
        if (value.length < 255) {
            setDescription(value);
            adjustHeight();
        }
    }

    return <>
        <Form.Control
            as="textarea"
            rows={row}
            className='description'
            onKeyDown={onKeyDown}
            onBlur={updateDescription}
            onChange={onChange}
            plaintext
            value={description}
            ref={inputRef}
        />
    </>;
}

export default Description;